import { OSType } from '@electricjs/core_entity-client';

const OSNameMap: Partial<Record<OSType, string>> = {
  [OSType.Windows]: 'Microsoft Windows',
  [OSType.Darwin]: 'macOS',
  [OSType.Android]: 'Android',
  [OSType.Ios]: 'iOS',
};

type GetOsFullNameParams = {
  osType: string | undefined;
  osName: string | undefined;
  osVersion: string | undefined;
};

export const getOsFullName = ({
  osType,
  osName,
  osVersion,
}: GetOsFullNameParams) => {
  if (!osType && !osName) {
    return '';
  }

  const maybeVersion = osVersion ? ` (${osVersion})` : '';
  const prettyName = osType ? OSNameMap[osType as OSType] : '';

  if (!osName) {
    return `${prettyName}${maybeVersion}`;
  }

  // Some systems (such as Intune) include the OS version in the name field
  const nameWithVersion =
    !osVersion || osName.includes(osVersion)
      ? osName
      : `${osName}${maybeVersion}`;

  if (osType === OSType.Darwin) {
    return !prettyName || nameWithVersion.includes(prettyName)
      ? nameWithVersion
      : `${prettyName} ${nameWithVersion}`;
  }

  // Windows system already includes the OS brand name as a part of the osName value
  return nameWithVersion;
};
